module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-45.cb759483.svg";